import * as React from 'react';

export const ChevronDownFilledIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
  >
    <path d="M0.5 0.75L9.5 0.75L5 5.25L0.5 0.75Z" fill="currentColor" />
  </svg>
);
